import DeckCommonCardsFilter from "@/lib/games/onePiece/DeckCommonCardsFilter";
import NameFilter from "@/components/Filters/NameFilter";
import SearchSelect, { dataUA } from "@/components/Filters/SearchSelect";
import { ColorFilterUA } from "@/components/Filters/ColorFilter";
import CostFilter from "@/components/Filters/CostFilter";
import { getCostData } from "@/components/DeckBuilder/game/unionArena/filterPossibleValues";
import APCostFilter from "@/components/DeckBuilder/game/unionArena/filters/APCostFilter";
import CardTypeFilter from "@/components/DeckBuilder/game/unionArena/filters/CardTypeFilter";
import ShowAAsFilter from "@/components/Filters/ShowAAsFilter";
import LangFilter from "@/components/DeckBuilder/game/unionArena/filters/LangFilter";
import ArchetypeFilter from "@/components/DeckBuilder/game/unionArena/filters/ArchetypeFilter";
// import UASetFilter, {
//   formats,
// } from "@/components/DeckBuilder/game/unionArena/filters/UASetFilter";
import UASetFilter from "@/components/Filters/UASetFilter";

import { Button } from "@heroui/react";
import { IFiltersUA } from "@/components/DeckBuilder/game/unionArena/filters/getDefaultFilters";
import BattlePowerFilter from "@/components/DeckBuilder/game/unionArena/filters/BattlePowerFilter";

interface DeckCardsMap {
  [key: string]: {
    count: number;
    cards: string[];
  };
}

// affinity

interface OPFiltersProps {
  filters: IFiltersUA;
  setFilter: (key: keyof IFiltersUA, value: any) => void;
  searchDisplay: string;
  setSearchDisplay: (value: string) => void;
  deckCardsMap: DeckCardsMap;
  clearAllFilters: () => void;
}

export default function UAFilters({
  filters,
  setFilter,
  searchDisplay,
  setSearchDisplay,
  deckCardsMap,
  clearAllFilters,
}: OPFiltersProps) {
  return (
    <div className="flex flex-wrap gap-2 mt-2 mb-2 items-center">
      <div className="flex flex-row">
        <SearchSelect
          selected={filters.searchSelect}
          setSelected={(val: any) => setFilter("searchSelect", val)}
          customData={dataUA}
        />
        <NameFilter
          selected={searchDisplay}
          setSelected={setSearchDisplay}
          placeholder={"Search"}
          rounded="rounded-l-none"
        />
      </div>
      <ArchetypeFilter
        selected={filters.archetype}
        setSelected={(val: any) => setFilter("archetype", val)}
        deckCardsMap={deckCardsMap}
        label="Archetype"
      />
      <UASetFilter
        selected={filters.set}
        setSelected={(val: any) => setFilter("set", val)}
      />
      <ColorFilterUA
        selected={filters.color}
        setSelected={(val: any) => setFilter("color", val)}
      />
      <CostFilter
        selected={filters.cost}
        setSelected={(val: any) => setFilter("cost", val)}
        customData={getCostData()}
      />
      <APCostFilter
        selected={filters.apCost}
        setSelected={(val: any) => setFilter("apCost", val)}
      />
      <BattlePowerFilter
        selected={filters.battlePower}
        setSelected={(val: any) => setFilter("battlePower", val)}
      />
      <CardTypeFilter
        selected={filters.cardType}
        setSelected={(val: any) => setFilter("cardType", val)}
      />
      <LangFilter
        selected={filters.lang}
        setSelected={(val: any) => setFilter("lang", val)}
      />
      <ShowAAsFilter
        selected={filters.showAAs}
        setSelected={(val: any) => setFilter("showAAs", val)}
      />
      <Button
        // color="primary"
        // variant=""
        onPress={() => {
          clearAllFilters();
        }}
        radius="sm"
        className="h-[30px]"
        // endContent={<IconX height={14} width={14} />}
      >
        Clear
      </Button>
    </div>
  );
}
